module.exports = __webpack_public_path__ + "img/11.50112179.jpg";